import React from 'react';
import { PropTypes } from 'prop-types';
import './LoginForm.scss';
import Input from '../../../Form/Input';
import Button from '../../../Button';
import { Link } from 'react-router-dom';
import SocialLogins from '../../../SocialLogins/SocialLogins';
import OneOnOneCard from '../../../CheckoutPartials/OneOnOneCard';

const LoginForm = ({
  onChange,
  onSubmit,
  error,
  formRef,
  isLoading,
  show1on1Card,
}) => {
  const className = 'c-LoginForm';

  return (
    <div className={className}>
      <SocialLogins />
      <div className={`${className}__or`}>OR</div>
      <form ref={formRef} onSubmit={onSubmit} className={`${className}__form`}>
        <div className={`${className}__form__input__wrapper`}>
          <Input
            className={`${className}__form__input`}
            onChange={onChange}
            type="email"
            name="email"
            placeholder="Email address"
            required
          />
        </div>
        <div className={`${className}__form__input__wrapper`}>
          <Input
            className={`${className}__form__input`}
            onChange={onChange}
            type="password"
            name="password"
            placeholder="Password"
            eyeIcon
            required
          />
        </div>
        {error && (
          <div className={`${className}__message ${className}__message--error`}>
            {error}
          </div>
        )}
        {isLoading && (
          <div
            className={`${className}__message ${className}__message--loading`}
          >
            Loading...
          </div>
        )}
        {show1on1Card && <OneOnOneCard />}
        <Button displayType="primary" type="submit">
          Login
        </Button>
        <Link
          title="Forgot Password"
          to={{ pathname: 'https://learn.nas.academy/forget-password' }}
          rel="noreferrer"
          target="_blank"
          className={`${className}__form__link`}
        >
          Forgot your password?
        </Link>
      </form>
    </div>
  );
};

LoginForm.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  error: PropTypes.string,
  formRef: PropTypes.object,
  isLoading: PropTypes.bool,
  show1on1Card: PropTypes.bool,
};

export default LoginForm;
